interface IProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

// Centered brand-colored link used to switch between the block's verification
// methods (SSN2 design: 15px medium, plum, no underline).
const SwitchStateLink = ({ label, onClick, disabled = false }: IProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="mt-5 w-full cursor-pointer text-center text-[15px] font-medium text-[#4f41a6] transition-colors hover:text-[#40336e] disabled:cursor-not-allowed disabled:opacity-50"
    >
      {label}
    </button>
  );
};

export { SwitchStateLink };
